import { render, staticRenderFns } from "./ActivateValidatorModal.vue?vue&type=template&id=31a223b8&scoped=true"
import script from "./ActivateValidatorModal.vue?vue&type=script&lang=js"
export * from "./ActivateValidatorModal.vue?vue&type=script&lang=js"
import style0 from "./ActivateValidatorModal.vue?vue&type=style&index=0&id=31a223b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a223b8",
  null
  
)

export default component.exports